import { Alert as MuiAlert, Button } from "@mui/material";
import { SETTINGS_CONFLICT } from "@/utils/alertCopy.ts";
import { saveErrorMessage } from "@/utils/notificationGroups.ts";

/** Why the last save failed; a conflict offers Reload. `other` are rejections no field shows. */
export default function SaveProblem({
  error,
  other,
  onReload,
}: {
  readonly error: unknown;
  readonly other: readonly string[];
  readonly onReload: () => void;
}) {
  const message = saveErrorMessage(error);
  const lines = message ? [message] : other;
  if (lines.length === 0) return null;
  const reload = (
    <Button color="inherit" size="small" onClick={onReload}>
      Reload
    </Button>
  );
  return (
    <MuiAlert severity="error" sx={{ mb: 2 }} action={message === SETTINGS_CONFLICT ? reload : undefined}>
      {lines.map((line, i) => (
        <div key={`${i}-${line}`}>{line}</div>
      ))}
    </MuiAlert>
  );
}
